"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DiscountCoupon = void 0;
const class_validator_1 = require("class-validator");
const mocks_1 = require("../../mocks");
const property_1 = require("../../decorators/property");
class DiscountCoupon extends mocks_1.Model {
}
exports.DiscountCoupon = DiscountCoupon;
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", String)
], DiscountCoupon.prototype, "title", void 0);
__decorate([
    (0, class_validator_1.IsString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, class_validator_1.Length)(6, 6),
    (0, property_1.Property)({ unique: true, index: true }),
    __metadata("design:type", String)
], DiscountCoupon.prototype, "code", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], DiscountCoupon.prototype, "amount", void 0);
__decorate([
    (0, class_validator_1.IsDateString)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", Date)
], DiscountCoupon.prototype, "endDate", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], DiscountCoupon.prototype, "perUserLimit", void 0);
__decorate([
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.IsNotEmpty)(),
    (0, property_1.Property)(),
    __metadata("design:type", Number)
], DiscountCoupon.prototype, "totalUsageLimit", void 0);
__decorate([
    (0, property_1.Property)({ type: [String], default: [] }),
    __metadata("design:type", Array)
], DiscountCoupon.prototype, "usages", void 0);
